import React, { useContext, useState, useEffect, useMemo } from 'react';
import { Link, useLocation } from "react-router-dom";

// import Logo from '../../Assets/Images/logo.png';
import logoLeft from '../../../Assets/Images/divine-renovation.svg';
import logoLeftMobile from '../../../Assets/Images/leftlogomob.png';
// import logoLeftMobile from '../../../Assets/Images/left-logo-mobile.svg';
// import bleatLogo from '../../../Assets/Images/logo-bleat-desktop.png';
// import bleatLogo from '../../../Assets/Images/assessment-logo-right.svg';
import logo from '../../../Assets/Images/missional-waypoint-logo.svg'
// import bleatLogo from '../../../Assets/Images/Bleatlogo.png';
// import bleatLogoMobile from '../../../Assets/Images/bleat-logo-mobile.png';
import useWindowDimensions from '../../../Hooks/useWindowDimensions';
// import assessmentTitle from '../../../Assets/Images/assessment-name.png'
import DashboardDownArrowRed from "../../../Assets/Images/dashboardDownArrowRed.png"
import { motion } from 'framer-motion';
import AuthContext from '../../../Store/AuthContext';
import { MenuItem, Select } from '@mui/material';
import LanguageContext from '../../../Store/LanguageContext';
import DashboardContext from '../../../Store/DashboardContext';
import MultipleAssessmentsContext from '../../../Store/MultipleAssessmentsContext';
// import AdditionalQuestionContext from '../../../Store/AdditionalQuestionContext';
import { isJsonString } from '../../../utils/helper';
import { translate } from '../../translate/translate';
import AdditionalQuestionContext from '../../../Store/AdditionalQuestionContext';
import { ShimmerDiv } from 'shimmer-effects-react';


//Assers/Images/flags
function importAll(r) {
  let images = {};
  r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
  return images;
}
const flagImages = importAll(require.context('../../../Assets/Images/Bleat-flags', false, /\.(png|jpe?g|svg)$/));
const Header = props => {

  const { windowWidth } = useWindowDimensions();
  const location = useLocation();
  const authCtx = useContext(AuthContext);
  const addCtx = useContext(AdditionalQuestionContext);
  const langCtx = useContext(LanguageContext);
  const dashboardCtx = useContext(DashboardContext);
  const multipleAssessmentsCtx = useContext(MultipleAssessmentsContext);
  const pathParts = location.pathname.split("/");
  const routeId = ["assessment", "progress-milestone", "results"].some(part => pathParts.includes(part)) ? pathParts[2] : null;

  const [currentLocation, setCurrentLocation] = useState(location.pathname);
  // const [parishDetails, setParishDetails] = useState()
  const [languages, setLanguages] = useState([
    { "value": "English" },
    { "value": "Nederlands" }
  ])
  const [dropdown, setDropdown] = useState(false)
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [formInfo, setFormInfo] = useState([]);

  const apiData = dashboardCtx.parishAPIData;
  const id = dashboardCtx.dashboardId || routeId;
  const userDetail = addCtx?.form1Details;

  const parishDetails = useMemo(() => {
    const details = {};

    dashboardCtx.parishOverviewAPIData?.fields?.forEach((el) => {
      if (el?.field_name === 'attendanceSliderValue') {
        details.attendance = el?.value;
      }
      if (el?.field_name === 'locationType') {
        details.locationType = el?.value;
      }
      if (el?.field_name === 'socioEconomic') {
        details.socioEconomic = el?.value;
      }
      if (el?.field_name === 'country') {
        details.country = el?.value;
      }
      if (el?.field_name === 'city') {
        details.city = el?.value;
      }
    });
    return details;
  }, [dashboardCtx.parishOverviewAPIData])

  console.log(dashboardCtx.parishOverviewAPIData?.fields)

  const handleTranslate = (text, type) => {
    console.log('langCtx.language: ', langCtx.language);
    console.log("type", type)
    console.log("text", text)
    const translations = {
      "socio-economic-group": {
        "Upper-Middle (top 50% of wage earners in the country but not rich)": {
          Nederlands: "Hoog-midden (bovenste 50% inkomens, maar niet rijk)",
          English: "Upper-Middle (top 50% of wage earners in the country but not rich)"
        },
        "Low (lower 20% of income earners)": {
          Nederlands: "Laag (20% laagste inkomens)",
          English: "Low (lower 20% of income earners)"
        },
        "Lower-Middle (bottom half of income earners, but not poor)": {
          Nederlands: "Laag-midden (onderste 50% inkomens, maar niet arm)",
          English: "Lower-Middle (bottom half of income earners, but not poor)"
        },
        "High Income (top 5% of income earners)": {
          Nederlands: "Hoog (5% hoogste inkomens)",
          English: "High Income (top 5% of income earners)"
        }
      },
      "location-type": {
        "Urban": { Nederlands: "Stad", English: "Urban" },
        "Sub-Urban": { Nederlands: "Voorstedelijk", English: "Sub-Urban" },
        "Rural": { Nederlands: "Platteland", English: "Rural" },
        "Other": { Nederlands: "Anders", English: "Other" }
      }
    };

    if (translations[type] && translations[type][text]) {
      return translations[type][text][langCtx.language] || text;
    }

    if (langCtx.language === "English") {
      for (const category in translations) {
        for (const key in translations[category]) {
          if (translations[category][key].Nederlands === text) {
            return key;
          }
        }
      }
    }
    return langCtx.language === "Nederlands"
      ? translate(text, "headerTranslateDutch", type)
      : text;
  };

  useEffect(() => {
    const firstFormData = localStorage.getItem('firstFormData')
    if (isJsonString(firstFormData)) {
      setFormInfo(JSON.parse(firstFormData))
    }
    getParishDetails(id);
    langCtx.fetchLanguagePreference(id, location.pathname);
  }, [id])

  useEffect(() => {
    setSelectedLanguage(langCtx.language);
  }, [langCtx.language]);

  const logoLeftBox = {
    initial: {
      position: "relative",
      top: "15px",
      opacity: 0
    },
    animate: {
      top: 0,
      opacity: 1,
      transition: {
        delay: 1.2,
        duration: 0.8,
        ease: [.175, .885, .32, 1.275],
      },
    },
  };

  const middleBox = {
    initial: {
      position: "relative",
      top: "15px",
      opacity: 0
    },
    animate: {
      top: 0,
      opacity: 1,
      transition: {
        delay: 1.6,
        duration: 0.8,
        ease: [.175, .885, .32, 1.275],
      },
    },
  };

  const rightLogoBox = {
    initial: {
      position: "relative",
      top: "15px",
      opacity: 0
    },
    animate: {
      top: 0,
      opacity: 1,
      transition: {
        delay: 2,
        duration: 0.8,
        ease: [.175, .885, .32, 1.275],
      },
    },
  };


  function getParishDetails(id) {
    const path = location.pathname;
    const shouldFetch = ["/resources", "/insights", "/compare", "/assessment", "/progress-milestone", "/results", "/overviewmultiassessment"].some(subPath => path.includes(subPath));

    if (shouldFetch && id?.length > 0) {
      const latestDeploymentId = multipleAssessmentsCtx.getLatestDeploymentId();
      const deploymentParam = latestDeploymentId ? `?deploymentId=${latestDeploymentId}` : '';

      // parishOverview
      if (Object.keys(dashboardCtx?.parishOverviewAPIData?.data || {}).length === 0) {
        fetch(`${process.env.REACT_APP_API_URI}/v4/user/assessment/${id}/parishOverview${deploymentParam}`, {
          method: 'GET',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' }
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              dashboardCtx.setParishOverviewAPIData({
                data: data?.data || {},
                fields: data?.fields || []
              });
            }
          })
          .catch(error => console.error("Failed fetching parishOverview:", error));
      }

      // parish
      if (Object.keys(dashboardCtx?.parishAPIData || {}).length === 0) {
        fetch(`${process.env.REACT_APP_API_URI}/v4/user/assessment/${id}/parish`, {
          method: "GET",
          mode: "cors",
          headers: { "Content-Type": "application/json" },
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              dashboardCtx.setParishAPIData(data?.data || {});
            }
          })
          .catch(error => console.error("Failed fetching parish:", error));
      }
    }
  }


  const calculateAttendanceValue = (value) => {
    const minStep = 100;
    const maxStep = 5000;
    const totalSteps = 14;
    const perStep = 7.14;

    const currentStep = Math.round(value / perStep);

    const stepSize = 4900 / 14;

    let resultValue;
    if (currentStep === 0) {
      resultValue = minStep;
    } else if (currentStep == 14) {
      resultValue = maxStep;
    }
    else {
      resultValue = stepSize * currentStep;
    }

    return resultValue
  };


  useEffect(() => {
    setCurrentLocation(location.pathname)
  }, [authCtx, window.location.pathname])

  useEffect(() => {
    if (!langCtx.isLanguageLoading && selectedLanguage !== langCtx.language) {
      langCtx.setLanguage(selectedLanguage);
      updateLanguagePreference(selectedLanguage);
    }
  }, [selectedLanguage])

  const updateLanguagePreference = async (language) => {
    const path = location.pathname;
    const shouldUpdate = ['before-you-start', 'assessment', 'results', 'dashboard'].some(subPath => path.includes(subPath));

    if (shouldUpdate && id) {
      try {
        const url = `${process.env.REACT_APP_API_URI}/v6/user/assessment/${id}/user`;
        const payload = {
          userDetails: [
            { field: "languagePreference", value: language }
          ]
        };
        await fetch(url, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        console.log('Language preference updated in background:', language);
      } catch (error) {
        console.error('Error updating language preference:', error);
      }
    }
  };

  const handleGoBackHome = () => {
    window.location.href = '/';
  };


  return (
    <>
      <header>
        <div>
          {!id ?
            <div className="header-wrapper">
              {/*<motion.div className="logo-left" initial="initial" animate="animate" variants={middleBox} id="assessment-title">
              </motion.div>*/}
              <img src={logo} alt="Logo" /*onClick={handleGoBackHome}*/ />
              <div className='translation-container'>
                {langCtx.isLanguageLoading ? (
                  <ShimmerDiv mode="light" height={40} width={120} rounded={5} />
                ) : (
                  <Select className="form-details-text"
                    value={selectedLanguage}
                    onFocus={(e) => { }}
                    onChange={(e) => setSelectedLanguage(e.target.value)}
                    displayEmpty={true}
                    renderValue={(selected) => {
                      if (!selected) {
                        return <div className="select-placeholder">Select Language</div>
                      }
                      return selected
                    }}
                  >
                    {languages.map((lang, i) => <MenuItem key={lang.value} value={lang.value}>{lang.value}</MenuItem>)}
                  </Select>
                )}
              </div>
            </div>
            :
            <div className='header-container'>
              <img src={logo} alt="" className='logo' /*onClick={handleGoBackHome}*/ />
              <div className="responsivediv">
                <div className='translation-container' >
                  {langCtx.isLanguageLoading ? (
                    <ShimmerDiv mode="light" height={40} width={120} rounded={5} />
                  ) : (
                    <Select className="form-details-text"
                      value={selectedLanguage}
                      onFocus={(e) => { }}
                      onChange={(e) => setSelectedLanguage(e.target.value)}
                      displayEmpty={true}
                      renderValue={(selected) => {
                        if (!selected) {
                          return <div className="select-placeholder">Select Language</div>
                        }
                        return selected
                      }}
                    >
                      {languages.map((lang, i) => <MenuItem key={lang.value} value={lang.value}>{lang.value}</MenuItem>)}
                    </Select>
                  )}
                </div>

                <div className='container-content'>
                  <div className="user-details">
                    <div className="flag">
                      {(() => {
                        const country = userDetail?.country || apiData?.parishDetails?.[0]?.country;
                        return country ? (
                          <img
                            src={flagImages[`${country}.png`]}
                            className="flag"
                            alt=""
                          />
                        ) : (
                          <ShimmerDiv mode="light" height={windowWidth > 650 ? 46 : 30} width={windowWidth > 650 ? 46 : 30} rounded={50} />
                        );
                      })()}
                    </div>

                    {(() => {
                      const diocese = userDetail?.diocese || apiData?.parishDetails?.[0]?.diocese;
                      const parish = userDetail?.parish || apiData?.parishDetails?.[0]?.parish;

                      return diocese ? (
                        <div className="names">
                          <h3>{parish}</h3>
                          <p>{diocese}</p>
                        </div>
                      ) : (
                        <div className="names-shimmer" >
                          <ShimmerDiv mode="light" height={windowWidth > 650 ? 16 : 10} width={windowWidth > 650 ? 150 : 80} rounded={5} />
                          <ShimmerDiv mode="light" height={windowWidth > 650 ? 16 : 10} width={windowWidth > 650 ? 150 : 80} rounded={5} />
                        </div>
                      );
                    })()}

                    {(location.pathname.includes("/dashboard") && parishDetails?.attendance) && (
                      <div className="dropdown" onClick={() => setDropdown(!dropdown)}>
                        <img
                          src={DashboardDownArrowRed}
                          alt=""
                          className={dropdown ? "open" : "close"}
                          width="12px"
                        />
                      </div>
                    )}
                  </div>

                  {location.pathname.includes("/dashboard") &&
                    <div className='tooltip' style={{ display: dropdown ? "block" : "none" }}>
                      <div className="score-arrow"></div>
                      <div className='tooltip-content'>
                        <p>{handleTranslate("Avg. Weekend Attendance", "weekly-attendance")}:<strong>{' '}{calculateAttendanceValue(parishDetails?.attendance)}</strong></p>
                        <p>{handleTranslate("Socio-Economic Group", "socio-economic")}:<strong>{' '}{handleTranslate(parishDetails?.socioEconomic, "socio-economic-group")}</strong></p>
                        <p>{handleTranslate("Parish Location", "parish-location")}:<strong>{' '}{handleTranslate(parishDetails?.locationType, "location-type")}</strong></p>
                        <p>{handleTranslate("Country", "first-form-country")}:<strong>{' '}{parishDetails?.country || userDetail?.country || '-'}</strong></p>
                        <p>{handleTranslate("City", "first-form-city")}:<strong>{' '}{parishDetails?.city || userDetail?.city || '-'}</strong></p>
                      </div>
                    </div>}
                </div>
              </div>

            </div>}
        </div>

      </header>
    </>
  )
}

export default Header;
